var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container, Paper } from '@mui/material';
import Typography from '@mui/material/Typography';
import React from 'react';
export var DefaultContentStep = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, _b = _a.children, children = _b === void 0 ? null : _b, style = _a.style;
    return (_jsxs("form", __assign({ noValidate: true, autoComplete: "off", style: __assign(__assign({}, style), { width: '100%' }) }, { children: [_jsx(Paper, __assign({ sx: { marginTop: 1, paddingBottom: 1, paddingTop: 1, background: 'transparent' } }, { children: _jsxs(Container, { children: [title &&
                            (_jsx(Typography, __assign({ variant: "h4", gutterBottom: true, align: "center" }, { children: title }))), subtitle &&
                            (_jsx(Typography, __assign({ variant: "subtitle1", gutterBottom: true, align: "center" }, { children: subtitle })))] }) })), children] })));
};
